import { Table } from '../../Table'
import styles from './AuditTable.module.scss'

export const AuditTable = ({ ...props }) => {
  return (
    <div className={styles.content}>
      <Table {...props} />
    </div>
  )
}
